import { createFileRoute } from "@tanstack/react-router";

import { CONCEPTION_COPY, ConceptionView } from "../components/tools/conception";
import { faqJsonLd } from "../components/tools/tool-layout";
import { seo } from "../lib/head";

export const Route = createFileRoute("/calcul-date-de-conception")({
  staticData: { ssr: true },
  head: () =>
    seo({
      title: "Calcul de la date de conception · Listou",
      description:
        "Estimez la date de conception de votre bébé à partir de vos dernières règles, de la date prévue d'accouchement ou de l'échographie.",
      jsonLd: faqJsonLd(CONCEPTION_COPY.faq),
    }),
  component: ConceptionView,
});
